import { createFileRoute } from '@tanstack/react-router';
import { EmailLinkCallbackPage } from '../pages/EmailLinkCallbackPage';

export const Route = createFileRoute('/email-callback')({
  component: EmailLinkCallbackPage,
});
